import * as React from 'react';
import { Box, Chip, Grid, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
var INFO_STRIP_SX = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    px: 2,
    py: 1.25,
    mb: 2,
    borderRadius: '8px',
    backgroundColor: '#EFF6FF',
};
var CARD_SX = {
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    overflow: 'hidden',
    backgroundColor: '#F9F9F9',
};
var CARD_HEADER_SX = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 2,
    py: 1.35,
    borderBottom: '1px solid #e7ebf1',
};
var CHIP_SX = {
    height: 20,
    fontSize: '10px',
    bgcolor: '#DBEAFE',
    color: '#2E75B6',
    fontWeight: 600,
    '& .MuiChip-label': { px: 1 },
};
var DETAIL_LABEL_SX = {
    fontSize: '10px',
    color: '#6E6E77',
    textTransform: 'uppercase',
    fontWeight: 400,
    letterSpacing: '0.02em',
};
var DETAIL_VALUE_SX = {
    fontSize: '14px',
    fontWeight: 400,
    color: '#000000',
    mt: 0.3,
    lineHeight: 1.3,
    wordBreak: 'break-word',
};
var GROUP_HEADING_SX = {
    fontSize: '14px',
    fontWeight: 600,
    color: '#000000',
    pb: 0.75,
    borderBottom: '1px solid #e7ebf1',
    mb: 1.15,
    lineHeight: 1.25,
};
var NOT_ANSWERED = '-';
var AUTO_POPULATED_NOTE = 'Guarantor Auto-Populated from Customer Information';
var Detail = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement(Box, null,
        React.createElement(Typography, { sx: DETAIL_LABEL_SX }, label),
        React.createElement(Typography, { sx: DETAIL_VALUE_SX }, value || NOT_ANSWERED)));
};
var SignerGuarantorPreview = function (_a) {
    var guarantors = _a.guarantors;
    if (guarantors.length === 0) {
        return null;
    }
    return (React.createElement(Box, { sx: { mb: 2 } },
        React.createElement(Box, { sx: INFO_STRIP_SX },
            React.createElement(InfoOutlinedIcon, { sx: { fontSize: 20, color: '#2E75B6' } }),
            React.createElement(Typography, { sx: { fontSize: '12px', fontWeight: 400, color: '#000000', lineHeight: 1.3 } }, AUTO_POPULATED_NOTE)),
        React.createElement(Stack, { gap: 2 }, guarantors.map(function (guarantor, guarantorIndex) { return (React.createElement(Box, { key: guarantor.customerLabel, sx: CARD_SX },
            React.createElement(Box, { sx: CARD_HEADER_SX },
                React.createElement(Typography, { sx: {
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#1f2430',
                        lineHeight: 1.25,
                    } }, "Individual"),
                React.createElement(Chip, { label: guarantorIndex === 0 ? 'Primary' : 'Additional', size: "small", sx: CHIP_SX })),
            React.createElement(Box, { sx: { px: 2, py: 1.75 } },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, md: 4, lg: 3 },
                        React.createElement(Detail, { label: "Name", value: guarantor.name })),
                    React.createElement(Grid, { item: true, xs: 12, md: 8, lg: 5 },
                        React.createElement(Detail, { label: "SSN", value: guarantor.taxpayerId })),
                    React.createElement(Grid, { item: true, xs: 12, md: 12, lg: 4 },
                        React.createElement(Detail, { label: "Date Of Birth", value: guarantor.dateOfBirth }))),
                React.createElement(Grid, { container: true, spacing: 2, sx: { mt: 0.8 } },
                    React.createElement(Grid, { item: true, xs: 12, md: 4, lg: 3 },
                        React.createElement(Typography, { sx: GROUP_HEADING_SX }, "Additional Details"),
                        React.createElement(Grid, { container: true, spacing: 1.25 },
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(Detail, { label: "Ownership%", value: guarantor.ownership
                                        ? "".concat(guarantor.ownership, "%")
                                        : '' })),
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(Detail, { label: "Business Title", value: guarantor.businessTitle })))),
                    React.createElement(Grid, { item: true, xs: 12, md: 8, lg: 5 },
                        React.createElement(Typography, { sx: GROUP_HEADING_SX }, "Contact Details"),
                        React.createElement(Grid, { container: true, spacing: 1.25 },
                            React.createElement(Grid, { item: true, xs: 12, sm: 7 },
                                React.createElement(Detail, { label: "Email", value: guarantor.email })),
                            React.createElement(Grid, { item: true, xs: 12, sm: 5 },
                                React.createElement(Detail, { label: "Phone Number", value: guarantor.phone })))),
                    React.createElement(Grid, { item: true, xs: 12, md: 12, lg: 4 },
                        React.createElement(Typography, { sx: GROUP_HEADING_SX }, "Home Address"),
                        React.createElement(Detail, { label: "Address", value: guarantor.address })))))); }))));
};
export default React.memo(SignerGuarantorPreview);
